module.exports = "/_next/static/images/ac92d063c13a09baa916c357efef8987-product-information-xs-1x.jpg";